'use client';

import { usePathname, useRouter } from '@/i18n/navigation';
import { Button } from "@/components/ui/button";
import { Globe } from 'lucide-react';
import { useTranslations } from 'next-intl';

export default function LanguageSwitcher({ locale }: { locale: string }) {
  const pathname = usePathname();
  const router = useRouter();
  const t = useTranslations('Navigation');

  const toggleLocale = () => {
    const newLocale = locale === 'en' ? 'de' : 'en';
    router.push(pathname, { locale: newLocale });
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleLocale}
      className="rounded-full"
      aria-label={t('switchLocale', { locale: locale === 'en' ? 'de' : 'en' })}
      role="button"
    >
      <Globe className="h-5 w-5" aria-hidden="true" />
    </Button>
  );
}
